import { PlanDetails } from '../typings/plans';

type Price = Pick<PlanDetails['price'], 'basePrice' | 'basePriceExcludingTax'>;

export function getPrice(price: Price, isBusiness: boolean): number | null {
  if (isBusiness) return price?.basePriceExcludingTax;
  return price?.basePrice;
}
